const companyName = import.meta.env.VITE_COMPANY_NAME;

export default {
  NavaTel: companyName,
  Navatel: companyName,
  navatel: companyName,
  Logout: "خروج",
  type: 'نوع',
  Service: 'خدمت',
  "Opps!!!": "ای وای",
  "This page you are looking for could not be found":
    "صفحه مورد نظر شما یافت نشد",
  "Go Back to Home": "بازگشت به خانه",
  Settings: "تنظیمات",
  "Theme Color": "تم رنگ روشن",
  "Theme Dark Color": "تم رنگ تیره",
  Home: "خانه",
  "User Profile": "مشخصات کاربر",
  "My Profile": "پروفایل من",
  "Account settings": "تنظیمات حساب کاربری",
  "My Inbox": "پیام های من",
  "Messages & Emails": "پیام ها و ایمیل ها",
  "My Tasks": "تسک های من",
  "To-do and Daily tasks": "وظایف و کارهای روزانه",
  Notifications: "اعلان ها",
  "See all Notifications": "مشاهده همه اعلان ها",

  "Users settings": "تنظیمات کاربری",
  "Definition of operator": "تعریف کاربر",
  "List of users": "لیست کاربران",
  "Role management": "مدیریت نقش",
  "Messages to operators": "ارسال پیام به کاربران",
  Contacts: "مخاطبین",
  CRM: "مدیریت ارتباط مشتری",
  people: "اشخاص",
  companies: "شرکت‌ها",
  "Call Setting": "تنظیمات تماس",
  settings: "تنظیمات تماس",
  "Call Forward": "تعریف شماره کال فوروارد",
  "Upload Recording": "بارگذاری فایل صوتی",
  "Upload Date": "تاریخ بارگذاری",
  Format: "فرمت",
  File: "فایل",
  Queue: "مدیریت صف",
  "Manage IVR": "مدیریت IVR",
  "Set Time Condition": "تعیین شروط زمانی",
  "Manage Voicemail": "مدیریت پیام های صوتی",
  "Black List": "لیست سیاه",
  "Call Destination": "مقصد تماس",
  Ratings: "نظرسنجی",
  Monitoring: "مانیتورینگ",
  Dashboard: "پیشخوان",
  Wallboard: "والبورد",
  "Live Call": "نمایش زنده تماس‌ها",
  "Users Status": "وضعیت کاربران",
  report: "گزارشات",
  hangupReason: "سوابق تماس",
  answered: "تماس های پاسخ داده شده",
  answeredNumber: "تعداد تماس‌های پاسخ‌داده‌شده",
  missed: "تماس های بی پاسخ",
  calls: "وضعیت تماس‌",
  missedNumber: "تعداد تماس‌های بی‌پاسخ",
  totalCallDuration: "مجموع زمان مکالمه",
  totalMissedWaitngDuration: "مجموع زمان انتظار در زمان قطع ارتباط",
  totalAnswereddWaitngDuration: "مجموع زمان انتظار در تماس‌های پاسخ داده‌شده",
  operatorActivity: "عملکرد پاسخگویی کاربر",
  cdr: "رکورد مکالمات",
  fullCdrs: "گزارش پیشرفته",
  scatteirng: "نمودار پراکندگی تماس‌ها",
  rating: "نتایج نظر سنجی مکالمات",
  cost: "نمودار تاریخچه هزینه‌ها",
  Cost: "هزینه‌",
  waiting: "نمودار صبر مشتری",
  Support: "پشتیبانی",
  "Insert New Ticket": "ایجاد تیکت",
  "Tickets List": "مشاهده تیکت های ارسالی",
  "ticket list": "لیست تیکت ها",
  "Connect to CRM": "اتصال به CRM",
  "CRM Numbers": "تعریف شماره مجاز CRM",
  "CRM Structure": "ساختار CRM",
  "CRM links": "لینک های اتصال به CRM",
  Fax: "فکس",
  "Insert New Fax": "ایجاد فکس",
  "Fax Date": " تاریخ فکس",
  "Fax Type": "نوع فکس",
  "Send Fax": "ارسال فکس",
  "Head number": "سر شماره",
  "Report of Submitted Fax": "فکس‌های ارسالی",
  "Report of Received Fax": "فکس‌های دریافتی",
  Webchat: "وب چت",
  "Insert New Websit": "تعریف وب‌سایت",
  "Insert Operator Number": "تعریف شماره اپراتور",
  "Insert Operator Number Title": "تعریف شماره اپراتور",
  "Manage Operator": "اپراتورها",
  "Manage Operator Title": "اپراتور‌ها",
  "Manage Roles": "مدیریت نقش‌ها",
  Department: "تعریف دپارتمان‌ها",
  department: "دپارتمان",
  "Department Name": "نام دپارتمان",
  "Enter Department Name": "نام دلخواه خود را وارد کنید.",
  Customize: "تنظیمات و شخصی سازی",
  noSite: "سایتی برای نمایش تنظیمات وجود ندارد.",
  Conversations: "گفتگوها",
  "No Item Exist": "آیتمی برای انتخاب موجود نیست.",
  "First Select Website": "ابتدا وب‌سایت را انتخاب کنید.",
  "Number Delete Successfully": "شماره با موفقیت حذف شد.",

  createLinkGuid: "برای ایجاد لینک جلسه کلیک کنید.",
  linkAddress: "آدرس لینک",
  copyNotPossible: "عدم پشتیبانی از کپی کردن",
  linkType: "نوع لینک",
  meetTitle: "عنوان جلسه",
  meetParticipantsNumber: "تعداد شرکت کنندگان",
  recordDeleteModalTitle: "حذف رکورد",
  videoConference: "ویدئو کنفرانس",
  createLinkTitle: "ایجاد لینک جدید",
  products: "محصولات",
  connectToWhatsapp: "اتصال به واتس‌اپ ",
  whatsappAccounts: "حساب‌های واتس‌اپ ",
  whatsapp: "واتس‌اپ",
  whatsappMessages: "پیامرسانی واتس‌اپ",
  enterWhatsapp: "ورود به واتس اپ",
  whatsappAdd: "ایجاد حساب واتس‌اپ",
  whatsappAddAccount: "افزودن حساب واتس‌اپ ",
  noAccountYet:
    "شما تاکنون حساب واتس‌اپ در سیستم تعریف نکرده‌اید! برای این منظور روی دکمه زیر کلیک نمائید. ",
  addWhatsAppAccount:
    "راهنما: با کلیک برروی دکمه افزودن حساب واتس‌اپ، امکان تعریف حساب جدید وجود دارد.",
  addWhatsAppAccountText: "افزودن حساب واتس‌اپ ",
  countryCode: "کد کشور",
  profileTitle: "عنوان پروفایل",
  profileTitlePlaceHolder: "عنوان مورد نظر خود را وارد کنید",
  lineNumber: "شماره خط",
  enterYourWhatsappLine: "شماره خط واتس‌اپ خود را وارد کنید",
  crmContactUpdate: "به‌روز رسانی مخاطبین CRM",
  contactAvatarUpdate: "به‌روزرسانی آواتار مخاطب    ",
  crmContactAutoCreate: "ایجاد خودکار مخاطبین CRM",
  samplePhone: "09129876543",
  return: "بازگشت",
  optional: " (اختیاری) ",
  enterDescription: "توضیحات مورد نظر خود را وارد کنید",
  inactive: "غیرفعال",
  connected: "متصل",
  qrcodeScan: "اسکن QR Code",
  WhatsAppConnect1: "واتس‌اپ را روی گوشی خود باز کنید.",
  WhatsAppConnect21: "روی منو",
  WhatsAppConnect22: "یا تنظیمات",
  WhatsAppConnect23: "کلیک کنید.",
  WhatsAppConnect3: "کد روبرو را اسکن کنید.",
  newCloseText: "خیر، بازگشت",
  newConfirmText: "بله، حذف",
  WhatsAppDelete1: "آیا از حذف حساب واتس‌اپ",
  WhatsAppDelete2: "مطمئن هستید؟",
  WhatsAppCreateSuccess: "حساب واتس‌اپ با موفقیت ایجاد شد.",
  WhatsAppAccountManagement: "مدیریت حساب‌های واتس‌اپ",
  newAccountAya: "آیا میخواهید یک حساب دیگر ایجاد کنید؟",
  newAccount: "ایجاد حساب جدید",
  editConfirmed: "تائید ویرایش",
  samplePlaceHolder: "دپارتمان توسعه فنی",
  receiver: "دریافت‌کننده",
  Sending: "ارسالی",
  Receiving: "دریافتی",
  whatsAppFileInputMessage: "فقط فایل‌های فرمت JPEG, PNG, SVG تا حجم 25MB.",
  enterMessageText: "متن پیام خود را وارد کنید!",
  messageText: "متن پیام",
  sendWhatsappMessage: "ارسال پیام واتس‌اپ",
  draft: "پیش‌نویس",
  noWhatsAppMessageYet:
    "شما تاکنون پیامی از این حساب واتس‌اپ ارسال نکرده‌اید! ",
  messageSentSuccessfully: "پیام با موفقیت ارسال شد.",
  meetDate: "تاریخ برگزاری",
  meetDuration: "مدت جلسه",
  recordDeleteModalText: "آیا برای پاک کردن رکورد مورد نظر اطمینان دارید؟",
  meetListPageTitle: "لیست رویدادها",
  writeDown: "پیام خود را یادداشت کنید..",
  chatPage: "صفحه چت",
  willScanLater: "بعدا اسکن می‌کنم",
  deleteWhatsappNumber: "حذف حساب واتس‌اپ",
  "": "",
  "": "",
  history: "تاریخچه",
  productHistory: "تاریخچه محصول",
  "": "",
  createLink: "ایجاد لینک",
  linkTitle: "عنوان جلسه",

  Invoice: "فاکتور",
  PreInvoice: "پیش‌فاکتور",
  "Document Number": "شماره سند",
  "Document Type": "نوع سند",
  "Customer Type": "نوع خریدار",
  "Customer Name": "نام خریدار",
  "Expiration Date": "تاریخ انقضا",
  "Payment Date": "تاریخ پرداخت",
  price: "مبلغ",
  "Add Invoice": "ایجاد فاکتور",
  "Add Invoice Text":
    "هنوز فاکتور یا پیش‌فاکتور ایجاد نشده است، برای ایجاد فاکتور روی دکمه زیر کلیک کنید.",
  "Add PreInvoice Text": "برای ایجاد پیش‌فاکتور روی دکمه زیر کلیک کنید.",
  "not found invoice": "فاکتور یا پیش‌فاکتوری با مشخصات وارد شده یافت نشد.",
  "Add PreInvoice": "ایجاد پیش‌فاکتور",
  "PreInvoice Currency": "ارز پیش‌فاکتور",
  "Invoice Currency": "ارز فاکتور",
  Naturalis: "حقیقی",
  Juridica: "حقوقی",
  Telephone: "تلفن",
  "Product Name": "نام محصول",
  "Unit Price": "مبلغ واحد",
  Count: "تعداد",
  "Discount Type": "نوع تخفیف",
  Amount: "مقدار",
  Discount: "تخفیف",
  Tax: "مالیات و عوارض",
  "Total Price": "مبلغ کل",
  percentage: "درصد",
  "PreInvoice Description": "توضیحات پیش‌فاکتور",
  "Final Price": "مبلغ نهایی",
  "Total Discount": "مجموع تخفیف",
  "Total Tax": "مجموع مالیات و عوارض",
  "Other Costs": "هزینه‌های دیگر",
  "Add New Row": "افزودن سطر جدید",
  "Amount To Pay": "مبلغ قابل پرداخت",
  "Amount To Pay Number": "مبلغ قابل پرداخت (به عدد)",
  "Amount To Pay Word": "مبلغ قابل پرداخت (به حروف)",
  Revocation: "ابطال",
  Revocationed: "ابطال شده",
  "convert to invoice": "تبدیل به فاکتور",
  "delete preinvoice": "حذف پیش‌فاکتور",
  "delete invoice": "حذف فاکتور",
  "delete preinvoice text": "آیا از حذف پیش‌‌فاکتور {item} مطمئن هستید؟",
  "delete invoice text": "آیا از حذف فاکتور {item} مطمئن هستید؟",
  "delete preinvoice successfully": "پیش‌فاکتور با موفقیت حذف شد",
  "delete invoice successfully": "فاکتور با موفقیت حذف شد",
  "Revocation Text": "آیا از ابطال فاکتور شماره {item} اطمینان دارید؟",
  "revocation note text": "ابطال ‌فاکتور به معنی عودت مبلغ آن به مشتری است.",
  "PreInvoice Number": "شماره پیش‌فاکتور",
  "Invoice Number": "شماره فاکتور",
  "Expiration Duration": "مدت انقضا",
  "Expiration Duration Text": "{day} روز بعد از ارسال پیش‌فاکتور",
  "Save Draft": "ذخیره در پیش‌نویس",
  "Send PreInvoice": "ارسال پیش‌فاکتور",
  "Send Invoice": "ارسال فاکتور",
  "PreInvoice Save To Draft Successfully":
    "پیش‌فاکتور با موفقیت در پیش‌نویس ذخیره شد.",
  "Invoice Send Successfully": "فاکتور با موفقیت ارسال شد",
  "PreInvoice Revocation Successfully": "پیش‌فاکتور با موفقیت ابطال شد.",
  "Invoice History": "تاریخچه فاکتور",
  "PreInvoice History": "تاریخچه پیش‌فاکتور",
  "Factor Search Text": "جستجوی شماره  سند، نام خریدار",
  "invoice and preinvoice setting": "تنظیمات پیش‌فاکتور و فاکتور",
  template: "قالب",
  "advance setting": "تنظیمات پیشرفته",
  "Eco Number": "شماره اقتصادی",
  "Enter your address": "آدرس را وارد کنید",
  "save settings": "ذخیره تنظیمات",
  vertical: "عمودی",
  horizontal: "افقی",
  "display type": "نوع نمایش",
  "upload company logo": "بارگذاری لوگوی شرکت",
  "upload background": "بارگذاری تصویر پس‌زمینه",
  "upload stamp and signature": "بارگذاری مهر و امضا",
  "distance from top": "فاصله از بالا (به پیکسل)",
  "distance from bottom": "فاصله از پایین (به پیکسل)",
  "distance from right": "فاصله از راست (به پیکسل)",
  "distance from left": "فاصله از چپ (به پیکسل)",
  "display logo on preinvoice": "نمایش لوگوی شرکت در پیش‌فاکتور",
  "display logo on invoice": "نمایش لوگوی شرکت در فاکتور",
  "display stamp and signature on preinvoice": "نمایش مهر و امضا در پیش‌فاکتور",
  "display stamp and signature on invoice": "نمایش مهر و امضا در فاکتور",
  "display background in preinvoice": "نمایش تصویر پس‌زمینه در پیش‌فاکتور",
  "display background in invoice": "نمایش تصویر پس‌زمینه در فاکتور",
  "preinvoice number format": "فرمت شماره پیش‌فاکتور",
  "invoice number format": "فرمت شماره فاکتور",
  "preinvoice starting number": "شماره شروع پیش فاکتور ",
  "invoice starting number": "شماره شروع فاکتور ",
  "default tax": "مقدار پیش فرض درصد مالیات",
  "show tax column": "نمایش ستون مالیات",
  "show product code": "نمایش کد کالا",
  "display count and amount of units": "نمایش تعداد و مبلغ واحد",
  "show discount column": "نمایش ستون تخفیف",
  "create QR in PDF": "ایجاد QR در خروجی PDF",
  "invoice description": "توضیحات فاکتور",
  "send in whatsapp": "ارسال با واتسپ",
  "copy link and download pdf": "کپی لینک و دانلود PDF",
  "send by sms": "ارسال با پیامک",
  "download pdf file": "دانلود فایل PDF",
  "text copy successfully": "متن با موفقیت کپی شد",
  "Enter sms text": "متن پیامک را وارد کنید",
  logo: "لوگو",
  "preinvoice date": "تاریخ پیش‌فاکتور",
  "invoice date": "تاریخ فاکتور",
  seller: "فروشنده",
  customer: "خریدار",
  "product name and code": "نام و کد محصول",
  "discount price": "مبلغ تخفیف",
  "total amount after discount": "مبلغ کل پس از تخفیف",
  total: "مجموع",
  "stamp and signature": "مهر و امضا",
  "background image": "تصویر پس‌زمینه",
  "Invoice Setting": "تنظیمات فاکتور",
  "convert to factor text": "آیا از تبدیل پیش‌فاکتور {item} به فاکتور مطمئن هستید؟",
  "note":"توجه:",
  "convert to invoice text": "تبدیل پیش‌فاکتور به فاکتور به معنی پرداخت مبلغ آن توسط مشتری است.",
  "preinvoice convert to invoice successfully": "پیش‌فاکتور با موفقیت به فاکتور تبدیل شد.",
  title: "عنوان",
  "Data is incorrect": "اطلاعات وارد شده صحیح نمی‌باشد",

  "Performance Evaluation": "ارزیابی عملکرد",
  "Save performance Evaluation": "ثبت ارزیابی عملکرد",
  "Save Evaluation": "ثبت ارزیابی",
  "Performance Evaluation Report": "گزارش ارزیابی عملکرد",
  seccode: "seccode",
  secretCode: "secret code",
  "Sign in Navatel": `ورود به ${companyName}`,
  Username: "نام کاربری",
  Password: "رمزعبور",
  "Remember Me": "مرا به خاطر بسپار",
  "Forget Password": "فراموشی رمز عبور",
  Login: "ورود",
  "Invalid Username Or Password": "نام کاربری یا رمز عبور اشتباه است.",
  "Enter the Cerification Code": "ورود کد تایید",
  "Enter the code sent to Navatel number below.":
    "کد فرستاده شده به نواتل شماره <span>{number}</span> را در زیر وارد کنید.",
  "Resubmit after:": "ارسال دوباره بعد از:",
  "Resubmit the code": "ارسال دوباره کد",
  "Didn't get the code?": "کد را دریافت نکرده‌اید؟",

  "Forgot Password": "رمزعبور خود را فراموش کرده‌اید؟",
  "Forgot Password Guide": `لطفا شماره ${companyName} خود را در فیلد زیر وارد کنید. ما یک لینک بازیابی رمز عبور به ${companyName} شما ارسال خواهیم کرد.`,
  "Number in Navatel": `شماره تلفن در اپلیکیشن ${companyName}`,
  "Enter Your Navatel": `شماره ${companyName} خود را وارد کنید`,
  "Back to Login": "بازگشت به خانه",
  "Not Found Number": "شماره مورد نظر یافت نشد",
  "Link Send Successfully": "لینک با موفقیت برای شما ارسال شد",

  "Reset Password": "بازیابی رمزعبور",
  "Reset Password Guide":
    "رمزعبور جدید خود را وارد کنید تا بتوانید به حساب‌تان دسترسی پیدا کنید.",
  "Enter Your New Password": "رمز عبور جدید خود را وارد نمایید",
  "Confirm Password": "تکرار رمزعبور",
  "Update Password Successfully": "رمزعبور شما با موفقیت به‌روزرسانی شد.",

  "Upload File": "بارگذاری فایل",
  "Recording Name": "نام فایل صوتی",
  Play: "پخش",
  "Upload Recording Guide":
    "حجم فایل شما نباید بیشتر از 5 مگابایت باشد.فرمت فایل باید mp3 یا wav باشد.",
  "File Is Required": "انتخاب فایل اجباری است.",
  "File Size Should Be Less Than": "حجم فایل باید کمتر از {size} باشد.",
  "Recording Upload Successfully": "فایل با موفقیت بارگذاری شد.",
  "Delete Recording": "حذف فایل صوتی",
  "Delete Recording Text": "آیا از حذف فایل صوتی {item} مطمئن هستید؟",
  "Recording Delete Successfully": "فایل صوتی با موفقیت حذف شد.",
  Recording: "فایل صوتی",
  "File Size Warning":
    "حجم فایل شما نباید بیشتر از 5 مگابایت باشد.فرمت فایل باید mp3 یا wav باشد.",

  "Enter Search Key": "کلمه کلیدی جستجو را وارد کنید.",
  "New User": "شخص جدید",
  "Choose State First": "ابتدا استان را انتخاب کنید",
  "Edit Contact": "ویرایش مخاطب",
  "Contact Information": "اطلاعات مخاطب",
  "Out Of Token":
    "تعداد توکن های شما به اتمام رسیده است. لطفا مجددا پنل خود را شارژ کنید.",
  "Data Insert Successfully": "اطلاعات با موفقیت ثبت شد",
  "Data Update Successfully": "اطلاعات با موفقیت ویرایش شد",
  "Sure To Call": "برقراری تماس",
  "Sure To Call Text": "آیا از برقراری تماس با  {item} مطمئن هستید؟",
  "Accept Call": "بله، برقراری تماس",
  Call: "تماس",
  "people Guide":
    "راهنما: با کلیک برروی افزودن شخص جدید، امکان تعریف پروفایل شخص وجود دارد.",

  "Create Date": "تاریخ ایجاد",
  "Select create date": "انتخاب تاریخ ایجاد",
  "Select send date": "انتخاب تاریخ ارسال",
  Row: "ردیف",
  Return: "بازگشت",
  "Fields Are Optional": "ثبت اطلاعات زیر اختیاری است.",

  "Create New Company": "شرکت جدید",
  "Edit Company Information": "ویرایش شرکت",
  "Company Information": "اطلاعات شرکت",
  "companies Guide":
    "راهنما: با کلیک برروی افزودن شرکت جدید، امکان تعریف پروفایل شرکت وجود دارد.",
  Website: "وب‌سایت",
  "Fax Number": "شماره فکس",
  "Head of fax number": "سر شماره فکس",
  "Select head of fax number": "انتخاب سر شماره فکس",
  "Creat head of fax number": "ایجاد سر شماره فکس",
  "Edit head of fax number": "ویرایش سر شماره فکس",
  "Agent Fullname": "نام‌ و نام‌خانوادگی نماینده‌شرکت",

  // Contact Details
  "Person Information": "اطلاعات شخص",
  "Main Information": "اطلاعات اصلی",
  "Personal Information": "اطلاعات شخصی",
  "Agent Information": "اطلاعات نماینده",
  "Main Phone Number": "شماره تماس اصلی",
  "Subscribe Information": "اطلاعات اشتراک",
  "Input Media": "رسانه ورودی",
  "Contact Status": "وضعیت مخاطب",
  "Lead Status": "وضعیت سرنخ",
  "Buying Chances": "احتمال خرید",
  "Estimated Purchase Amount": "پیش بینی مبلغ خرید",
  "Result Of Last Connection": "نتیجه آخرین ارتباط",
  "Submitter Operator": "کارشناس ثبت کننده",
  "FollowUp Operator": "کارشناس پیگیری",
  "Accept Edit": "تایید ویرایش",
  "National Code": "کد ملی",
  "Company Name": "نام شرکت",
  "Business Name": "نام کسب و کار",
  "Business Information": "اطلاعات کسب و کار",
  "Company National Id": "شناسه ملی",
  Major: "حوزه فعالیت",
  "Eco Code": "کد اقتصادی",
  "Unique Code": "کد یکتا",
  "My Company Number": `شماره ${companyName}`,
  "Whatsapp Number": "شماره واتس‌اپ",
  "Telegram Number": "شماره تلگرام",
  "Landline Phone": "تلفن ثابت",
  "Profile Creation Date": "تاریخ ایجاد پروفایل",
  Gender: "جنسیت",
  Birthday: "تاریخ تولد",
  State: "استان",
  City: "شهر",
  Address: "آدرس",
  "Postal Code": "کد پستی",
  Activities: "فعالیت‌ها",
  Telegram: "تلگرام",
  Sms: "پیامک",
  "Mobile Number": "شماره موبایل",
  "Sent Sms List": "صفحه پیامک‌ها",
  "Create Sms": "ایجاد پیامک",
  "Select Origin Number": "انتخاب شماره مبدا",
  "Sms Text": "متن پیامک",
  "Sms subject": "موضوع پیامک",
  "Sms type": "نوع پیامک",
  "Enter Your Text": "متن خود را وارد کنید",
  Avatar: "عکس پروفایل",
  "Select Your File": "فایل را انتخاب کنید",
  "Add Contact": "افزودن مخاطب",
  "Delete Contact": "حذف مخاطب",
  "Contact number search": "جستجوی شماره مخاطب",
  "Subject or sms text search": "جستجوی موضوع یا متن پیامک",
  "Delete Contact Text": "آیا از حذف مخاطب {item} اطمینان دارید؟",
  "Contact Delete Successfully": "مخاطب با موفقیت حذف شد.",
  "Contact Insert Successfully": "مخاطب با موفقیت افزوده شد.",
  "All Calls": "همه تماس‌ها",
  "Missed Call": "تماس از دست‌رفته",
  Missed: "از دست‌رفته",
  "Next Follow Up Date": "تاریخ پیگیری بعدی",
  Reminder: "یادآوری",
  "Reminder Time": "انتخاب تاریخ یادآوری",
  "No Reminder": "بدون یادآوری",
  "Minutes ago": "{item} دقیقه قبل",
  "Hours ago": "{item} ساعت قبل",
  "Days ago": "{item} روز قبل",
  "Select Custom Date": "انتخاب تاریخ دلخواه",
  "At Follow Up": "در زمان پیگیری",
  "Call Duration": "مدت زمان تماس",
  "Reasons For Calling": "دلایل تماس",
  "Add Call Reason": "ثبت دلیل تماس",
  "Call Reason": "دلیل تماس",
  "Call Id": "شناسه تماس",
  "Call Reason Insert Successfully": "دلیل تماس با موفقیت ثبت شد",
  "Call To Landing": "تماس با شماره ثابت",
  "Call To Main": "تماس با شماره اصلی",
  "Job Position": "سمت",
  Note: "یادداشت",
  "Submit Note": "ثبت یادداشت",
  "Edit Note": "ویرایش یادداشت",
  "Insert Note": "افزودن یادداشت",
  "Note Title": "عنوان یادداشت",
  "Note Text": "متن یادداشت",
  "Note Insert Successfully": "یادداشت با موفقیت افزوده شد",
  "Identity Documents": "مدارک هویتی",
  Upload: "بارگذاری",
  "Upload Identity Documents": "بارگذاری مدارک هویتی",
  "Edit Identity Documents": "ویرایش مدارک هویتی",
  "Upload Attachments": "بارگذاری پیوست",
  "Edit Attachments": "ویرایش پیوست",
  "Document Title": "نام مدرک",
  "Document File": "فایل مدرک",
  attachments: "پیوست‌ها",
  "Delete File": "حذف فایل",
  "Delete File Text": "آیا از حذف فایل {item} مطمئن هستید؟",
  "File Delete Successfully": "فایل با موفقیت حذف شد.",
  "File Inser Successfully": "فایل با موفقیت افزوده شد.",
  "File Update Successfully": "اطلاعات فایل با موفقیت به‌روزرسانی شد.",
  "Delete Note": "حذف یادداشت",
  "Delete Note Text": "آیا از حذف یادداشت {item} مطمئن هستید؟",
  "Note Delete Successfully": "یادداشت با موفقیت حذف شد.",
  "Note Inser Successfully": "یادداشت با موفقیت افزوده شد.",
  "Note Update Successfully": "یادداشت با موفقیت ویرایش شد.",
  Calling: "در حال تماس!",
  Rial: "ریال",
  Excel: "Excel",
  "Advance Filter": "جستجوی پیشرفته",
  "Delete All": "پاک کردن همه",
  doDelete: "پاک کردن ",
  Clear: "پاک کردن",
  To: "تا",
  Yesterday: "دیروز",
  Today: "امروز",
  "Send Message": "پیام ارسالی",
  "Recive Message": "پیام دریافتی",
  Comments: "نظرها",
  "Add Comment": "نظردهی",
  "Online Chat": "چت آنلاین",
  Typing: "در حال نوشتن...",
  "Recording Voice": "در حال ضبط صدا...",
  "Sending File": "در حال ارسال فایل...",
  Picture: "تصویر",
  "Queue Guide": "راهنما: در این قسمت امکان ایجاد صف (داخلی ها) وجود دارد.",
  "Insert Queue": "ایجاد صف",
  Extention: "داخلی",
  "Extention ": "داخلی {text}",
  "Queue Name": "نام صف",
  "Insert Queue Callcenter": "ایجاد صف مرکز تلفن",
  "Select Strategy": "انتخاب استراتژی زنگ خوردن",
  "Call All Operators": "همه کاربران زنگ بخورد",
  "ring all": "همه کاربران زنگ بخورد",
  "Round Robin Algorithm": "تصادفی با الگوریتم راندرابین",
  "round robin": "تصادفی با الگوریتم راندرابین",
  "Operator With Min Talk Time": "کاربر با حداقل زمان مکالمه",
  "agent with least talk time": "کاربر با حداقل زمان مکالمه",
  "Order Of Operators": "بر اساس ترتیب کاربر",
  "top down": "بر اساس ترتیب کاربر",
  "Select Waiting Voice": "انتخاب آوای انتظار در صف",
  "Waiting Voice": "آوای انتظار در صف",
  "Max Waiting Time": "حداکثر زمان انتظار",
  "Max Waiting Time Any Operator Available":
    "حداکثر زمان انتظار وقتی هیچ کاربری در دسترس نیست",
  "Max Waiting Time No Operator Available":
    "حداکثر زمان انتظار وقتی کاربر در دسترس نیست",
  "Action For Expired Queue Time":
    "در صورت به پایان رسیدن زمان انتظار در صف، عملیات را انتخاب کنید.",
  "Activate Call Recording": "فعال سازی ضبط مکالمه",
  "Expired Queue Time": "در صورت به پایان رسیدن زمان انتظار در صف",
  "Activate Polling Of Incoming Calls": "فعال سازی نظرسنجی تماس‌های ورودی",
  "Hide Caller ID Of Incoming Call":
    "پنهان سازی کالر آیدی تماس‌های ورودی برای صف",
  "Caller ID": "کالر آیدی",
  "Number Of People Waiting": "اعلام تعداد نفرات در صف",
  "Waiting Time In Queue": "اعلام مدت زمان انتظار در صف",
  "Leaving Queue And Go Back": "امکان خروج از صف و بازگشت به مرحله قبل",
  "Leave Key": "کلید خروج از صف",
  "Leave Action": "در صورت خروج از صف، عملیات را انتخاب کنید.",
  Active: "فعال",
  Deactive: "غیر فعال",
  All: "همه",
  "Queue Insert Successfully": "صف با موفقیت افزوده شد.",
  "Queue Update Successfully": "صف با موفقیت ویرایش شد.",
  "Delete Queue": "حذف صف",
  "Delete Queue Text": "آیا از حذف صف {item} مطمئن هستید؟",
  "Queue Delete Successfully": "صف با موفقیت حذف شد.",
  "Add Operator To Queue": "افزودن کاربر به مرکز تماس",
  "Add Operator To Queue Title": "برای افزودن کاربر روی تیک سبز رنگ کلیک کنید",
  "Add Operator To Queue Text":
    ' برای اعمال ترتیب زنگ خوردن کاربران پس از تنظیم "استراتژی زنگ خوردن" مرکز تماس به "بر اساس ترتیب کاربر" ردیف شماره ها را جابجا کنید ',
  "this call not for you": "این تماس متعلق به شما نیست",

  "Ivr Guide":
    "راهنما: در این قسمت امکان اضافه کردن منوی IVR برای انتخاب داخلی ها و بارگذاری صوت وجود دارد.",
  "Insert Ivr": "ایجاد منوی IVR",
  "Internal ID": "شناسه داخلی",
  Name: "نام",
  last_name: "نام خانوادگی",
  "minutes seconds": "(ثانیه/دقیقه)",
  "Select Recording File": "انتخاب فایل صوتی",
  "Duration Connection Operator": "مدت زمان اتصال به کاربر",
  "Duration Connection Previous Operator":
    "مدت ذخیره ماندن اتصال به کاربر قبلی به دقیقه",
  "Connect Call To Previous Operator": "اتصال تماس به کاربر قبلی",
  "Select Action IVR Finished": "انتخاب عملکرد بعد از به پایان رسیدن منوی IVR",
  "Add Extention": "ثبت داخلی",
  "Add VIP Extention": "ثبت داخلی اختصاصی",
  "Ivr Insert Successfully": "IVR با موفقیت افزوده شد.",
  "Ivr Update Successfully": "IVR با موفقیت ویرایش شد.",
  "Delete Ivr": "حذف آی‌وی‌آر",
  "Delete Ivr Text": "آیا از حذف آی‌وی‌آر {item} مطمئن هستید؟",
  "Ivr Delete Successfully": "IVR با موفقیت حذف شد.",

  "Call Destination Guide":
    "راهنما: برای دریافت تماس ها، عمل مورد نظر را انتخاب نمایید.",
  "Channel Name": "نام کانال",
  Wallet: "موجودی",
  "Number Of Calls": "تعداد کل تماس‌ها‌",
  "Number Of Call": "تعداد تماس",
  Incoming: "ورودی",
  Outgoing: "خروجی",
  "Answered Incoming Call": "تماس‌ ورودی پاسخ داده شده",
  "Answered Outgoing Call": "تماس‌ خروجی پاسخ داده شده",
  "Unanswered Incoming Call": "تعداد تماس‌های ورودی بی‌پاسخ",
  "Unanswered Outgoing Call": "تعداد تماس‌های خروجی بی‌پاسخ",
  "Time Of Outgoing Calls": "دقایق مکالمه تماس‌های خروجی",
  "Time Of Incoming Calls": "دقایق مکالمه تماس‌های ورودی",
  "Average Waiting Time": "میانگین زمان انتظار",
  "Max Waiting Time": "بیشترین زمان انتظار",
  "Min Waiting Time": "کمترین زمان انتظار",
  "Average Talk Time": "میانگین زمان مکالمه",
  "Max Talk Time": "بیشترین زمان مکالمه",
  "Min Talk Time": "کمترین زمان مکالمه",
  "Average Incoming Talk Time": "میانگین زمان مکالمه ورودی",
  "Average Out Talk Time": "میانگین زمان مکالمه خروجی",
  "Cost Of Calls": "هزینه تماس‌ها",
  ASR: "سطح سرویس ارائه خدمت",
  "Cloud Memory": "فضای ابری",
  "Total Memory": "فضای کل",
  "Remaining Memory": "فضای باقی‌مانده",
  "Used Memory": "فضای مصرف شده",
  MB: "مگابایت",
  Version: "ورژن",

  "Total Incoming Call": "کل تماس  ورودی",
  "Total Outgoing Call": "کل تماس  خروجی",
  "Operator Available To Call": " کاربران حاضر برای تماس",
  "Total Customers In IVR": " مشتریان در IVR",
  "Number Of Incoming Calls Answered": " تماس‌ ورودی پاسخ داده شده",
  "Number Of Outgoing Calls Answered": " تماس‌ خروجی پاسخ داده شده",
  "Number Of Simultaneous Calls": " همزمانی تماس",
  "In Use": "در حال استفاده",
  Free: "آزاد",
  "Total Customers In Queue": " مشتریان در صف",
  "Number Of Incoming Calls Dropped": " تماس‌ ورودی قطع شده (توسط مشتری)",
  "By Customer": "(توسط مشتری)",
  "Number Of Outgoing Unanswered Calls": " تماس‌ بی پاسخ خروجی",
  "The Number Of Operators In Conversation": " کاربر در حال مکالمه",
  "Poll Score": "امتیاز نظرسنجی",
  "Number Of Incoming Unanswered Calls": " تماس‌ بی پاسخ ورودی",
  "Number Of Incoming Calls": " تماس های ورودی",
  "Number Of Operators To Answer": " کاربر برای پاسخگویی",
  "Number Of Operators In Incoming Conversation": " کاربر در حال مکالمه ورودی",
  "Number Of Simultaneous Incoming Calls": " همزمانی تماس ورودی",
  "Average Incoming Talk time": "میانگین زمان مکالمه ورودی",
  "Full Screen": "تمام صفحه",

  Origin: "مبدا",
  Destination: "مقصد",
  "Waiting Time": "زمان انتظار",
  "Call Duration": "مدت زمان مکالمه",
  Whisper: "نجوا",
  "Call Control": "کنترل تماس",
  "Enter Conversation": "ورود به مکالمه",
  "Waiting For Call": "در انتظار تماس",
  "Outgoing Call": "تماس خروجی",
  "In Outgoing Call": "در حال تماس خروجی",
  "Incoming Call": "تماس ورودی",
  Divert: "دایورت",

  "User Name": "نام کاربر",
  "User Number": "شماره کاربر",
  "User Status": "وضعیت کاربر",
  "Status Duration": "مدت زمان وضعیت",
  "Change Operator Status": "آیا نسبت به تغییر وضعیت اپراتور مطمئن هستید؟",
  Rest: "استراحت",
  Launch: "ناهار",
  Arrest: "مرخصی",
  Holiday: "تعطیلات",
  "In Meeting": "جلسه",

  "Fax Insert Guide":
    "راهنما: برای ایجاد و ارسال فکس، با کلیک برروی ایجاد فکس،  آدرس ایمیل خود را وارد نمایید.",
  "ID:Enter Uniqe Number": "شناسه: یک عدد غیر تکراری وارد نمایید.",
  "Enter Your Email": "ایمیل خود را وارد نمایید.",
  "Fax Insert Successfully": "فکس با موفقیت افزوده شد.",
  "Fax Update Successfully": "فکس با موفقیت ویرایش شد.",
  "Delete Fax File": "حذف فایل فکس",
  "Delete Fax File Text": "آیا از حذف فایل فکس با شناسه  {item} مطمئن هستید؟",
  "Delete Fax": "حذف فکس",
  "Delete Fax Text": "آیا از حذف فکس  {item} مطمئن هستید؟",
  "Fax Delete Successfully": "فکس با موفقیت حذف شد",
  ID: "شناسه",
  "Email Address": "آدرس ایمیل",
  Actions: "عملیات",

  "Select Origin": "انتخاب مبدا",
  "Destination Number": "شماره مقصد",
  "Destination Internal Number": "شماره داخلی مقصد(اختیاری)",
  "Try to Send": "تعداد تلاش برای ارسال",
  Description: "توضیحات",
  "Select pdf": "انتخاب فایل pdf",
  "Select File": "فایل را انتخاب کنید",
  "Drag and Drop": "فایل خود را بکشید و رها کنید",
  or: "یا",
  "Fax Send Successfully": "فکس با موفقیت ارسال شد",

  "Fax Sender Number": "شماره ارسال کننده فکس",
  "Received Date": "تاریخ دریافت",
  "Received Time": "ساعت دریافت",
  Status: "وضعیت",
  "Recieve Status": "وضعیت دریافت",
  success: "موفق",
  failed: "ناموفق",
  "File Unavailable": "فایل در دسترس نیست.",
  "Fax File Delete Successfully": "فایل فکس با موفقیت حذف شد",
  Next: "بعدی",
  Previous: "قبلی",

  "Fax Reciever Number": "شماره دریافت کننده فکس",
  "Send Status": "وضعیت ارسال",
  "Send Date": "تاریخ ارسال",
  "Send Time": "ساعت ارسال",

  DepartmentGuid:
    'راهنما: با استفاده از قابلیت "ایجاد دپارتمان"، می\u200Cتوانید تیم\u200Cهایی با تخصص\u200Cهای متفاوت بسازید و برای هرکدام اپراتور مخصوص اختصاص دهید.',
  CreateDepartment: "افزودن دپارتمان",
  queueName: "نام تیم",
  queueDescription: "توضیحات",
  DeleteDepartment: "حذف دپارتمان",
  EditDepartment: "ویرایش دپارتمان",
  WillDeleteDepartment: "آیا از حذف دپارتمان {item} مطمئن هستید؟",
  addAgentToQueModalTitle: "اپراتورها",
  clickToAddAgent: "برای افزودن اپراتور روی تیک سبز رنگ کلیک کنید",
  noAgentForSelectedOperator: "اپراتوری برای این دپارتمان موجود نیست",
  "Enter Description": "توضیحات را وارد کنید!",
  "Change Agents Of Department": "اپراتورهای دپارتمان با موفقیت ویرایش شد.",

  WebsiteList: "لیست وبسایت‌ها",
  WebsiteListGuid:
    "راهنما: شما می‌توانید در اینجا ضمن مشاهده لیست سایت‌ها، تکه کد منحصر به فرد هر سایت را دریافت کنید.",
  AddWebsite: "افزودن وب‌سایت",
  EnterUrlHereExample: "لطفا URL وب‌سایت را وارد کنید.",
  Example: "مثال: {item}",
  WebSiteName: "عنوان وب‌سایت",
  "Enter Site Name": "نام دلخواه خود را وارد کنید",
  WebsiteAddress: "آدرس وب‌سایت",
  "Select Website": "انتخاب وب‌سایت",
  Activation: "فعال‌سازی",
  Guide: "راهنما",
  "Website Insert Successfully": "وبسایت با موفقیت افزوده شد.",
  "Website upadated Successfully": "وبسایت با موفقیت بروزرسانی شد.",
  GetCode: "دریافت تکه کد",
  AddCodeToHeader: "لطفا تکه کد را در Head وب‌سایت سایت اضافه کنید.",
  SetWebsiteCode: "نصب تکه کد در وبسایت",
  SnippetCode: "تکه کد",
  copyCode: "کپی تکه کد",
  close: "بستن",
  WebsiteCodeGuide:
    "راهنما: لطفا تکه کد ایجاد شده را در Header سایت خود قرار دهید.",
  TextCopied: "متن کپی شد.",
  operatorRegister: "ثبت شماره اپراتور",
  operatorNubmber: "شماره اپراتور",
  operatorRegisterModalGuide: `یک شماره که در پیام رسان ${companyName} اکانت دارد را وارد کرده و در مرحله بعد، آن را بوسیله کد تاییدی که پیام رسان ${companyName} ارسال می‌شود، تایید کنید.`,
  operatorRegisterGuide: `راهنما: شماره‌ای که دارای اپلیکیشن ${companyName} می‌باشد را اضافه کرده و با استفاده از کلید ذخیره آن را فعال کنید.`,
  operatorRegisterPlaceHolder: "شماره موبایل را با 98 وارد کنید.",
  enterNumber: "شماره را وارد نمایید",
  operatorRegisterButtonTitle: "افزودن شماره اپراتور",
  confirmNumber: "تایید شماره",
  verifyCode: "کد تایید",
  operationDone: "عملیات مورد نظر با موفقیت انجام شد",
  webChatOperatorsNumbers: "شماره‌ اپراتورهای وب چت",
  numberDeleteModalTitle: "حذف شماره",
  numberDeleteModalText: "آیا از حذف شماره  {item} مطمئن هستید؟",
  "Manage Operator Guid":
    "راهنما: برای فعالسازی سطح دسترسی و ایجاد یوزر برای ایجنت‌ این قسمت را کامل نمایید.",
  "Add User Operator": "تعریف اپراتور",
  registerOperator: "ثبت شماره اپراتور",
  selectNumbers: "شماره های مورد نظر را انتخاب کنید.",
  DashboardWebchat: "پیشخوان",
  DashboardWebchatGuidText: "پیام‌های ارسالی و دریافتی بر حساب اپراتور",
  "Selected Operator": "اپراتورهای انتخاب شده",

  operatorAcceessLevel: "سطح دسترسی اپراتور",
  "Manage role Guid":
    "راهنما: امکان تعیین سطح دسترسی برای نقش اپراتور وجود دارد.",
  WhatOperatorAccesses:
    "اپراتورها چه دسترسی هایی در سامانه گفتگوی آنلاین شما داشته باشند؟",
  enterRoleName: "نام نقش را وارد کنید.",
  "Add Operator": "افزودن اپراتور",
  "Edit Operator": "ویرایش اپراتور",
  Others: "دیگر",
  "Role Name Duplicate": "نام وارد شده تکراری است.",

  "From Date": "از تاریخ",
  "To Date": "تا تاریخ",
  "Do Select": "انتخاب کنید",
  "Phone Number": "شماره تماس",
  Search: "جستجو",
  "No Record": "رکوردی یافت نشد",
  "Loading Table Text": "لطفا صبر کنید",
  "oprator number": "شماره کاربر",
  enterNumber: "شماره را وارد نمایید",
  Save: "ذخیره",
  Select: "انتخاب",
  Send: "ارسال",
  Submit: "ثبت",
  Cancel: "انصراف",
  No: "خیر",
  Ok: "باشه",
  "Submit OTP": "ارسال کد تایید",
  Confirm: "تایید",
  Continue: "ادامه",
  "Can Not Connect To Server": "خطا در اتصال به سرور",
  "Action Do Successfully": "عملیات مورد نظر با موفقیت انجام شد.",
  "Delete Item Text": "برای حذف  {item} اطمینان دارید؟",
  "Delete Item": "حذف",
  edit: "ویرایش",

  Delete: "حذف",
  Edit: "ویرایش",
  "Users List": "لیست کاربران",
  Users: "کاربران",
  "File Upload": "آپلود فایل",
  View: "مشاهده",
  Pause: "توقف",
  "Copy Link": "کپی لینک",
  "Entering Meeting": "ورود به جلسه",
  Download: "دانلود",
  Preview: "پیش‌نمایش",
  Information: "اطلاعات",

  "from date": "از تاریخ",
  "to date": "تا تاریخ",
  "phone number": "شماره تلفن",
  search: "جستجو",
  "no record": "رکوردی یافت نشد",
  "no reports": "گزارش یافت نشد!",
  "loading table text": "لطفا صبر کنید",

  "call type": "نوع تماس",
  "queue name": "نام صف",

  users: "تنظیمات کاربری",
  Operator: "تعریف کاربر",
  "operator ID": "شناسه کاربر",
  "operator type": "نوع کاربر",
  "Help: To define your call center operator, click on Registration of operator number":
    "راهنما: برای تعریف کاربر مرکز تماس خود، بر روی ثبت شماره کاربر کلیک کرده و نوع کاربر را انتخاب نمایید.",
  "Registration of operator number": "ثبت شماره کاربر ",
  "Registration of operator": "ثبت کاربر ",
  "Operator Type": "کاربر",
  operator: "کاربر",
  "callcenter operator": "کاربر مرکز تماس",
  Family: "نام خانوادگی",
  Number: "شماره",
  FullName: "نام و نام خانوادگی",
  "Enter FullName": "نام و نام خانوادگی را وارد کنید",
  "Navatel user": `کاربر ${companyName}`,
  "Navatel users (username, password)": `کاربران ${companyName} (یوزرنیم پسورد)`,
  "ip-Phone": "آی‌پی‌فون",
  "User registration with mobile number": "ثبت کاربر با شماره موبایل",
  "User registration with username and password":
    "ثبت کاربر با نام کاربری و رمز عبور",
  "ip-Phone user registration": "ثبت کاربر آی‌پی‌فون",
  "with mobile number": "با شماره موبایل",
  "mobile number": "شماره موبایل",
  "with username and password": "با نام کاربری و رمز عبور",
  "with ip-Phone": "با آی‌پی‌فون",
  "Enter your number with 98": "شماره موبایل خود را وارد با 98 نمایید",
  "UserName (Enter your number with 98)":
    "نام کاربری (شماره موبایل خود را وارد با 98 نمایید)",
  "English lowercase letters and numbers":
    "رمز باید شامل حروف کوچک انگلیسی و عدد باشد",
  "The password must contain lower case English letters and numbers":
    "رمز عبور شامل حروف کوچک انگلیسی و عدد باشد",
  "Enter the verification code": "کد تایید را وارد کنید",
  "Navatel number confirmation": `تایید شماره ${companyName}`,
  "Confirmation and final registration of Navatel number - enter the confirmation code sent to the desired number in Navatel messenger": ` تایید و ثبت نهایی شماره ${companyName} - کد تاییدی که برای شماره مورد نظر شما در پیام رسان ${companyName} ارسال شده است را وارد کنید `,
  "NNavaNumber Insert Successfully": `اطلاعات کاربر ${companyName} با موفقیت ثبت شد`,
  "NNavaNumber Delete Successfully": `اطلاعات کاربر ${companyName} با موفقیت حذف شد`,
  "NNavaNumber Update Successfully": `اطلاعات کاربر ${companyName} با موفقیت ویرایش شد`,
  "NavaAccount Insert Successfully": `اطلاعات کاربر ${companyName} با موفقیت ثبت شد`,
  "NavaAccount Delete Successfully": `اطلاعات کاربر ${companyName} با موفقیت حذف شد`,
  "Account Insert Successfully": "اطلاعات کاربر آی‌پی‌فون با موفقیت ثبت شد",
  "Account Delete Successfully": "اطلاعات کاربر آی‌پی‌فون با موفقیت حذف شد",
  "Delete Operator Title": "حذف کاربر",
  "Delete Operator Text": "کاربر حذف خواهد شد. اطمینان دارید؟",
  "Are you sure you want to delete user?":
    "آیا از حذف کاربر {item} مطمئن هستید؟",
  "Are you sure you want to delete role?":
    'آیا از حذف نقش "<b>{text}</b>" مطمئن هستید؟',
  "No, back": "خیر، بازگشت",
  "Yes, delete": "بله، حذف",
  "Yes, Send": "بله، ارسال",
  "All Operators": "همه کاربران",
  Operators: "{text} کاربر",
  systemSettings: "تنظیمات سامانه",
  onlineConversationTitle: "عنوان باکس گفتگوی آنلاین:",
  onlineConversationTitlePlaceholder:
    "نام نمایش داده شده برای کاربران هنگام کلیک بر روی باکس گفتگو",
  welcomeMessage: "پیام خوش آمدگویی",
  welcomeMessagePlaceholder:
    "متن پیشفرض نمایش داده شده هنگام باز کردن صفحه گفتگوی آنلاین",
  beginningMessage: "پیام شروع",
  beginningMessagePlaceholder: "متن خودکار ارسالی برای شروع گفتگو با مشتری",
  popupContent: "متن پاپ‌آپ:",
  popupContentPlaceholder: "متن پاپ‌آپ",
  popupTitle: "عنوان پاپ‌آپ:",
  popupTitlePlaceholder: "عنوان پاپ‌آپ",
  operatorResponseStrategy: "استراتژی پاسخگویی کاربران",
  ReplacementOnTheSite: "جایگشت در سایت:",
  leftMargin: "فاصله از چپ:",
  rightMargin: "فاصله از راست:",
  bottomMargin: "فاصله از پایین:",
  choosePhoto: "انتخاب تصویر:",
  onlineConversationLanguage: "زبان گفتگوی آنلاین",
  chooseColor: "انتخاب رنگ:",
  chooseColorPlaceHolder: "انتخاب رنگ:",
  "Department Text": "متن پیش‌فرض انتخاب دپارتمان",
  "Submit Settings": " ثبت تنظیمات ",
  "Delete Role Text": "آیا از حذف نقش {item} مطمئن هستید؟",

  "Base Information": "اطلاعات پایه",
  "Template And Colors": "قالب و رنگ‌بندی",
  "Make Form": "ایجاد فرم",
  "Time Conditions": "شرط‌های زمانی",
  "Learn Bot": "آموزش بات",
  "Modal Title": "عنوان مودال",
  "Status Indicator": "نشانگر وضعیت",
  "Enter Start Message": "پیام شروع را وارد کنید!",
  "Start Text Hint":
    "اولین پیامی که به مخاطب از طرف سیستم به صورت خودکار ارسال می‌شود.",
  "Guide Text": "متن راهنما",
  "Enter Welcome Text": "متن خوش‌آمدگویی را وارد کنید!",
  "Enter Guide Text": "متن راهنما را وارد کنید!",
  "Show Questions First": "ابتدا سوالات متداول نمایش داده شود.",
  "Entering phoneNumber is required": "ورود شماره تماس اجباری باشد.",
  "Upload Logo": "بارگذاری لوگو",
  "Upload Avatar": "بارگذاری آواتار",
  "Logo Hint": "ابعاد پیشنهادی: 20x20 پیکسل، فرمت PNG.",
  "Default Logo": "لوگوهای پیش فرض",
  "Default Avatar": "آواتارهای پیش فرض",
  "Show In Website": "نمایش در وب‌سایت",
  "Only Main Page": "فقط صفحه اصلی",
  "All Pages": "همه صفحات",
  "Show In Mobile": "نمایش در موبایل",
  "Select Theme": "انتخاب تم رنگی",
  "Select Custom Theme": "انتخاب رنگ دلخواه",
  "Copy Right Navatel": "طراحی و اجرا توسط نواتل",
  "Create Form As": "ایجاد فرم به صورت",
  Integrate: "یکپارچه",
  "Every Department": "هر دپارتمان",
  "Question Number": "سوال متداول شماره {number}",
  "Answere Number": "پاسخ سوال متداول شماره {number}",
  "Add Question": "افزودن سوال متداول",
  "Add Question Department": "افزودن سوالات دپارتمان جدید",
  "Question List Update": "لیست سوال‌ها با موفقیت ویرایش شد",
  "Show Popup": "پاپ‌آپ نمایش داده شود.",
  "Normal Days": "روزهای عادی",
  "Special Days": "روزهای خاص",
  Sunday: "یک‌شنبه",
  Monday: "دوشنبه",
  Tuesday: "سه‌شنبه",
  Wednesday: "چهارشنبه",
  Thursday: "پنج‌شنبه",
  Friday: "جمعه",
  Saturday: "شنبه",
  "Working Day": "روز کاری",
  Vacation: "تعطیل",
  "Webchat In Vacation": "وضعیت وب‌چت در روزهای تعطیل",
  "Webchat In Special": "وضعیت وب‌چت در روزهای خاص",
  "Offline Message": "پیام آفلاین",
  "Send Smart Message": "ارسال پیام هوشمند",
  "Send To Whatsapp": "ارسال پیام‌ها به واتسپ",
  "Hide Chat Box": "عدم نمایش چت‌باکس در ساعت غیرکاری",
  "Disable Chat": "غیرفعال کردن امکان چت",
  "Offline Message Text":
    "مخاطب بعد از وارد کردن اطلاعات، پیامی مبتنی برپایان ساعت کاری دریافت می‌کند",
  "Enter Message": "پیام را وارد کنید",
  "Add Special Day": "افزودن روز خاص",
  "Click To Add Special Day": "برای افزودن روزهای خاص روی دکمه زیر کلیک کنید.",

  crmNumbersTitle: "تعریف شماره مجاز CRM",
  crmNumbersGuidNoNum:
    "در حال حاضر شماره ای افزوده نشده است. برای این کار از دکمه ی افزودن استفاده نمایید.",
  crmGuidNumbers:
    "راهنما:  برای اتصال کاربران برای تنظیمات سی آر ام، شماره کاربر را وارد نمایید.",
  crmNumberAddButton: "افزودن",
  crmNumberReturnButton: "بازگشت",
  crmContactNumber: "شماره تماس",
  crmAddModalText:
    "در این بخش باید شماره با با پیش شماره ۹۸ و بدون صفر وارد نمایید.",
  crmTypeTitle: "نوع CRM انتخابی:",
  crmUrl: "آدرس URL :",
  crmUrlPlaceholder: "url",
  crmSettingsTitle: "ساختار CRM",
  crmSettingsGuide:
    "برای اتصال یه سی ار ام لطفا نوع سی ارام خود را انتخاب نمایید.",
  crmSettingDeleteWarning: "آیا از حذف ساختار {item} مطمئن هستید؟",
  crmSettingDeleteTitle: "حذف ساختار CRM",
  crmUsersTitle: "لینک‌های اتصال به CRM",
  connectPhone: "شماره تلفن جهت اتصال",
  apiKey: "api key",
  serverNo: "serverno",
  crmUserDeleteWarning: "آیا از حذف سی‌آرام {item} مطمئن هستید؟",
  crmUserDeleteTitle: "حذف سی‌آرام",
  crmSettingsDeleteError: "حذف crm به درستی انجام نشد.",
  crmNoUrlDana: " به جای کلمه ی domain، لطفا نام دامنه خود را وارد نمایید.",
  "Access to the microphone is not possible":
    "دسترسی به میکروفون امکان پذیر نیست",
  domain: "domain",
  Domain: "دامنه",
  url: "url",

  crmLinksGuide:
    "راهنما: برای اتصال نهایی، لینک های لازم را برحسب نوع سی آر ام تکمیل نمایید.",
  "Managing the access level of call center operators":
    "مدیریت سطح دسترسی کاربران مرکز تماس",
  "Help: To activate the role of operators, select their number and specify the role. As soon as the role is selected for the user, the username and password will be sent to Navatel": `راهنما: برای فعالسازی نقش کاربرها، شماره کاربران را هنگام کلیک برروی افزودن انتخاب کرده و نقش را مشخص نمایید. به محض انتخاب نقش برای کاربر، نام کاربری و رمز عبور داخل ${companyName} ارسال میشود.`,
  "Operator Number": "شماره‌ کاربر",
  Role: "نقش",
  reporter: "گزارشگیر",
  Reporter: "گزارشگیر",
  "admin-reporter": "گزارشگیر ادمین",
  "Admin-reporter": "گزارشگیر ادمین",
  "Admin-Reporter": "گزارشگیر ادمین",
  admin: "ادمین",
  Admin: "ادمین",
  support: "پشتیبانی",
  "super-admin": "مدیر",
  "Super-admin": "مدیر",
  "Super-Admin": "مدیر",
  "no access": "بدون دسترسی",
  "Add user": "افزودن کاربر",
  "Edit user": "ویرایش کاربر",
  "Remove The Number Title": "حذف شماره",
  "Remove The Number Text": "شماره حذف خواهد شد. اطمینان دارید؟",
  download: "دانلود",
  "SubUsers Insert Successfully": "اطلاعات کاربر با موفقیت ثبت شد",
  "SubUsers Update Successfully": "اطلاعات کاربر با موفقیت ویرایش شد",
  "SubUsers Delete Successfully": "اطلاعات کاربر با موفقیت حذف شد",
  "Select the desired numbers": "شماره های مورد نظر را انتخاب کنید",
  "Access to all call center facilities": "دسترسی به همه امکانات مرکز تماس",
  "Access to call center menus": "دسترسی به منوهای مرکز تماس",
  "Access to call center settings": "دسترسی به تنظیمات مرکز تماس",
  "Full access to reports": "دسترسی کامل به گزارشات",
  "View reports": "مشاهده گزارشات",
  "Ability to send tickets and follow up": "امکان ارسال تیکت و پیگیری",
  "Click on the icon opposite to view": "برای مشاهده روی آیکن روبرو کلیک کنید",
  "Default Item": "از پیش تعیین شده",
  "User Item": "وارد شده توسط مشتری",
  "Managing the role of call center operators": "مدیریت نقش کاربران مرکز تماس",
  "Help: Please select your role name in Latin":
    "راهنما: برای ایجاد نقش، لطفا نام نقش خود را انگلیسی انتخاب نمایید.",
  "Add role": "افزودن نقش",
  "Add a new role": "افزودن نقش جدید",
  "Edit role": "ویرایش نقش",
  "Register a new role": "ثبت نقش جدید",
  "Enter the role name in English": "نام نقش را به انگلیسی وارد کنید",
  "Select all": "انتخاب همه",
  "Cancel all": "لغو همه",
  Feature: "{count} ویژگی",
  Accesses: "دسترسی ها",
  "Role Name": "نام نقش",
  "Role Type": "نوع نقش",
  "Delete Permissions Title": "حذف نقش",
  "Delete Permissions Text": "نقش حذف خواهد شد. اطمینان دارید؟",
  "Permissions Insert Successfully": "اطلاعات نقش با موفقیت ثبت شد",
  "Permissions Edit Successfully": "اطلاعات نقش با موفقیت ویرایش شد",
  "Permissions Delete Successfully": "اطلاعات نقش با موفقیت حذف شد",
  "Show Default Role": "نمایش سطح دسترسی نقش پیشفرض",
  "Show Role": "نمایش سطح دسترسی",
  subscriptionName: "subscription name",
  "Your number of authorized numbers is over":
    "تعداد شماره های مجاز شما تمام شده است",

  "Send messages to operators": "ارسال پیام به کاربران",
  "Send messages to navatel": "ارسال پیام به نواتل",
  "Channels that have destinations are displayed here. From this section, set the list of numbers to which you can send messages and send your message":
    "راهنما: از این بخش لیست کاربرانی که میتوانید به آن ها پیام ارسال نمایید را انتخاب کرده و پیام خود را ارسال نمایید.",
  "By default, the message will be sent to all numbers; You can select the list of received numbers using the blue button":
    "بصورت پیش فرض پیام برای تمام شماره ها ارسال خواهد شد؛ با استفاده از دکمه ی آبی رنگ می توانید لیست شماره های دریافتی را انتخاب نمایید",
  Text: "متن",
  Message: "پیام",
  "Enter the description!": "توضیحات را وارد کنید!",
  "Message recipients": "دریافت‌کننده‌های پیام",
  "Send the Message Title": "ارسال پیام",
  "Are you sure you want to send a message from the channel?":
    "آیا از ارسال پیام از کانال {item} مطمئن هستید؟",
  "Send the Message Text":
    "پیام شما به همه ی مخاطبانی که انتخاب کرده اید ارسال خواهد شد. اطمینان دارید؟",
  "Message Insert Successfully": "ارسال پیام با موفقیت انجام شد",

  Subject: "موضوع",
  Add: "افزودن",
  "Manage message recipients": "مدیریت دریافت کنندگان پیام",
  "By default, all numbers receive messages":
    "به صورت پیشفرض تمام شماره ها دریافت کننده پیام هستند",
  "Note: By default, all numbers receive messages":
    "توجه: به صورت پیشفرض تمام شماره ها دریافت کننده پیام هستند",
  "Number of selected users:": "تعداد کاربران انتخاب‌ شده: {text}",
  "No message has been entered": "پیامی وارد نشده است",
  "No number has been selected": "هیچ شماره ای انتخاب نشده است",

  "Help: Enter the number (landline, mobile) to divert calls":
    "راهنما: شماره (ثابت، همراه) برای دایورت تماس ها وارد نمایید",
  "Diverted number": "شماره دایورتی",
  "Add number": "ثبت شماره",
  "Registration of call forward number": "ثبت شماره کال فوروارد",
  "Help: enter the desired number and then save it":
    " راهنما: شماره مورد نظر را وارد و سپس آن را ذخیره نمایید",
  "Enter the number with 98": "شماره را با 98 وارد نمایید",
  "Enter the mobile number with 98": "شماره موبایل را با 98 وارد نمایید",
  "(UserName) Enter the mobile number with 98":
    "(نام کاربری) شماره موبایل را با 98 وارد نمایید",
  "CallForward Insert Successfully":
    "اطلاعات شماره کال فوروارد با موفقیت ثبت شد",
  "CallForward Delete Successfully":
    "اطلاعات شماره کال فوروارد با موفقیت حذف شد",
  "Delete CallForward Title": "حذف شماره کال فوروارد",
  "Delete CallForward Text": "آیا از حذف شماره {item} مطمئن هستید؟",
  "The entered number is duplicate": "شماره وارد شده تکراری است",
  "The entered username is duplicate": "نام‌کاربری وارد شده تکراری است",

  "Help: In this section, it is possible to add numbers that are in the black list for not making calls":
    "راهنما: در این قسمت، امکان افزودن شماره‌هایی که در لیست سیاه برای عدم برقراری تماس قرار می‌گیرند، وجود دارد",
  "Help: enter the number and click save to enter the black list":
    "راهنما: شماره را وارد و برای وارد شدن به لیست سیاه بر روی ذخیره کلیک نمایید",
  "Add Number To Black List": "افزودن شماره به لیست سیاه",
  "Add Number Here": "افزودن شماره",
  "BlackList Insert Successfully": "اطلاعات شماره لیست سیاه با موفقیت ثبت شد",
  "BlackList Delete Successfully": "اطلاعات شماره لیست سیاه با موفقیت حذف شد",
  "Delete BlackList Title": "حذف شماره لیست سیاه",
  "Delete BlackList Text": "شماره لیست سیاه حذف خواهد شد. اطمینان دارید؟",

  "Help: To create a voice mailer, upload the desired sound in the upload field and enter your email for the voice message":
    "راهنما: برای ایجاد پیام‌گیر صوتی، صوت مورد نظر را در قسمت آپلود بارگذاری کرده و برای پیام صوتی، ایمیل خود را وارد نمایید",
  "Add voicemail": "ایجاد پیام‌گیر صوتی",
  Email: "ایمیل",
  "Email to ...": "ایمیل شود به ...",
  "Important note: Your file size should not be more than 5 MB. The file format must be mp3 or wav, otherwise the file will not be sent":
    "نکته مهم: حجم فایل شما نباید بیشتر از 5 مگابایت باشد. فرمت فایل باید mp3 یا wav باشد در غیر این صورت فایل ارسال نخواهد شد",
  "Voicemail messages": "پیام های پیام‌گیر صوتی",
  Date: "تاریخ",
  Duration: "مدت",
  Messages: "پیام‌ها",
  "are you sure to delete the voice mail": "آیا از حذف پیام صوتی شماره",
  "VoiceMail Insert Successfully": "اطلاعات پیام‌ صوتی با موفقیت ثبت شد",
  "VoiceMail Update Successfully": "اطلاعات پیام‌ صوتی با موفقیت ویرایش شد",
  "VoiceMail Delete Successfully": "اطلاعات پیام‌ صوتی با موفقیت حذف شد",
  "VoiceMail Upload Successfully": "فایل پیام‌ صوتی با موفقیت آپلود شد",
  "VoiceMail Greeting Successfully": "فایل پیام‌ صوتی با موفقیت ثبت شد",
  "VoiceMailMessage Delete Successfully": "پیام‌ صوتی با موفقیت حذف شد",
  "Delete VoiceMail Title": "حذف اطلاعات پیام‌گیر صوتی",
  "Delete VoiceMail Text": "آیا از حذف پیام‌گیر صوتی {item} مطمئن هستید؟",
  "Delete VoiceMail Messsage Title": "حذف پیام صوتی",
  "Delete VoiceMail message Text": "آیا از حذف پیام‌ صوتی {item} مطمئن هستید؟",
  "Delete VoiceMailMessage Title": "حذف پیام‌ صوتی",
  "Delete VoiceMailMessage Text": "پیام‌ صوتی حذف خواهد شد. اطمینان دارید؟",
  "File input": "انتخاب فایل",
  "Select your files": "انتخاب فایل",
  view: "مشاهده",
  "answer ticket": "پاسخ تیکت",
  Answered: "پاسخ دهنده",
  Writer: "نویسنده",
  "Add New Person": "افزودن شخص جدید",
  "View Contact": "نمایش مخاطب",
  "Add New Company": "افزودن شرکت جدید",
  "Upload Information": "بارگذاری اطلاعات",
  "Upload Information Guide":
    "شما در اینجا میتوانید اطلاعات خود را از طریق بارگذاری فایل به صورت یکجا وارد کنید.",
  "Download Sample File": "دانلود نمونه فایل",
  "Drop File Hear": "فایل را بکشید و اینجا بیندازید  یا",
  "XLSX Format": "فقط فایل با فرمت XLSX.",
  "Got it": "متوجه شدم",
  "Some Minutes To Update Information":
    "به روزرسانی اطلاعات شما ممکن است تا چند دقیقه دیگر طول بکشد. ",

  "Add TimeCondition": "ایجاد شرط زمانی",
  "Edit TimeCondition": "ویرایش شرط‌های زمان بندی شده",
  "Help: It is possible to create time conditions to set receiving calls in different time periods":
    "راهنما: امکان ایجاد شروط زمانی برای تنظیم دریافت تماس ها در بازه زمانی مختلف وجود دارد",
  Priority: "اولویت",
  "TimeCondition Insert Successfully": "اطلاعات شرط زمانی با موفقیت ثبت شد",
  "TimeCondition Update Successfully": "اطلاعات شرط زمانی با موفقیت ویرایش شد",
  "TimeCondition Delete Successfully": "اطلاعات شرط زمانی با موفقیت حذف شد",
  "Delete TimeCondition Title": "حذف اطلاعات شرط زمانی",
  "Delete TimeCondition Text": "آیا از حذف شرط زمانی {item} مطمئن هستید؟",
  "Enter a name": "یک نام وارد کنید",
  Conditions: "شرایط",
  Start: "شروع",
  End: "پایان",
  "The process": "عمل",
  "According to the previous time conditions, enter the priority as a number":
    "با توجه به شروط زمانی قبلی الویت را به صورت عدد وارد کنید",
  Enter: "وارد کنید",
  "Enter to number": "به صورت عددی وارد کنید",
  Select: "انتخاب کنید",
  Enable: "فعال",
  Year: "سال",
  Month: "ماه",
  "Day of the Month": "روزی از ماه",
  "Day of the Week": "روزی از هفته",
  "Week of the Year": "هفته از سال",
  "Week of the Month": "هفته از ماه",
  Hour: "ساعت",
  "Hour of the Day": "ساعتی از روز",
  "Date and Time": "تاریخ و زمان",
  "empty notification": "هیج اعلانی برای شما وجود ندارد",

  "Filling this field is mandatory": "پر کردن این فیلد اجباری است",
  "The value entered is not valid": "مقدار وارد شده معتبر نیست",
  "Text Copied": "متن کپی شد",

  "Responsive operator": "اپراتور پاسخگو",
  "All conversations": "همه گفتگوها",
  "Unread conversations": "پیام خوانده نشده",
  "Read conversations": "پیام خوانده شده",
  "Write your text here": "پیام خود را یادداشت کنید..",
  "There is no dialogue to show": "گفتگویی برای نمایش وجود ندارد",
  "Choose one of the conversations and start":
    "یکی از گفتگوها را انتخاب و شروع کنید",
  "Select Department": "انتخاب دپارتمان",
  "Select Operator": "انتخاب اپراتور",
  "Enter Name Or Number": "نام یا شماره مخاطب را وارد کنید",
  "Select Date Of Last Message": "انتخاب تاریخ آخرین پیام",

  "remove cdr": "حذف سوابق تماس",
  "alert for remove cdr": "آیا از حذف سابقه تماس با شناسه {item} مطمئن هستید؟",
  "alert for remove cdrs": "آیا از حذف سوابق تماس انتخاب شده مطمئن هستید؟",
  "From Time": "از ساعت",
  "To Time": "تا ساعت",

  "Numbers Of": "شماره‌های {title}",
  "Divert Numbers": "شماره های دایورتی",
  "Call Centers": "مراکز تماس",
  "IVR Menus": "منوهای IVR",
  "Time Conditions": "شرط های زمانی",
  "Voice Mail": "پیام گیر صوتی",

  "field required": "فیلد اجباری است",
  "Complete Required Field": "فیلدهای اجباری را با دقت پر کنید.",

  "download sounds": "دانلود صوت ها",
  "delete sounds": "حذف صوت ها",

  "Items per page": "تعداد در هر صفحه",
  "{0} to {1} from {2}": "{0} تا {1} از {2}",
  from: "از",
  to: "تا",
  Users: "کاربران",
  "Added Extention": "افزودن داخلی",
  company: "شرکت",
  company: "شرکت",

  "evaluation info": "اطلاعات ارزیابی کننده",
  "evaluation master": "کارشناس ارزیابی کننده",
  "evaluation date": "تاریخ ارزیابی:",
  evaluation: "ارزیابی",
  oprator: "اپراتور",

  "evaluation time": " زمان ارزیابی",
  ringing: "در حال زنگ خوردن",
  selected: "انتخاب کنید",

  // table
  "Items Per Page": "تعداد در هر صفحه",

  From: "از",
  To: "تا",

  "Real time monitoring of the call center": "پایش لحظه ای مرکز تماس",
  "diconect deatail": "دلیل قطع ارتباط",

  create: "ایجاد",

  send: "ارسال",
  "send a single": "ارسال تکی",
  "send a single SMS": "ارسال پیامک تکی",
  "create sms": "ایجاد پیامک",
  "send report": "گزارش ارسال",
  "report receive": "گزارش دریافت",
  "Message subject": "موضوع پیامک",
  "Message text": "متن پیامک",
  "Select the source number": "انتخاب شماره مبدا",
  "Enter phone number": "ورود شماره تلفن",
  "enter subject": "موضوع را وارد کنید",
  "enter text": "متن را وارد کنید",
  "select subject": "انتخاب موضوع پیش‌فرض",
  "save subject": "ذخیره در پیش فرض ها",
  "select text": "انتخاب متن پیش‌فرض",
  "save text": "ذخیره در پیش فرض ها",
  "Select from contact list": "انتخاب از دفترچه تلفن",
  "default subjects": "موضوع های پیشفرض",
  "default messages": "پیام های پیش فرض",
  paste: "جاگذاری",
  "send sms": "ارسال پیامک",
  "send timing": "زمان بندی ارسال",
  "Send Confirmation": "تایید ارسال",
  "Send Confrimation text": "آیا از ارسال پیامک مطمئن هستید؟",
  "no back": "خیر , بازگشت",
  "yes send": "بله , ارسال",
  "yes remove": "بله , حذف",
  "yes submit": "بله , تائید",
  "recivers count": "تعداد گیرندگان",
  "sending price": "هزینه ارسال",
  "Set Send Time": "زمان دهی ارسال",
  "select send date": "انتخاب تاریخ ارسال",
  "select receive date": "انتخاب تاریخ دریافت",
  "select send time": "زمان را انتخاب کنید(دقیقه/ساعت)",
  minuteHour: "(دقیقه/ساعت)",
  "report receive send": "گزارش ارسال و دریافت",
  "report send": "گزارش ارسال ",
  "send status": "وضعیت ارسال",
  filter: "فیلتر",
  "users monitoring": "مانیتورینگ کاربران",
  "send a bulk": "ارسال انبوه",
  "send bulk guide": "راهنما: شما امکان ارسال پیامک به یک گیرنده را دارید.",
  "upload contacts file": "آپلود فایل مخاطبین",
  "send a groups SMS": "ارسال  گروهی",
  "Select group contacts": "انتخاب گروه مخاطبین",
  "group contacts": " گروه مخاطبین",
  "create group": "ایجاد گروه",
  "create group contacts": "ایجاد گروه مخاطبین",
  "group name": "نام گروه",
  "enter name group": "نام گروه را وارد کنید",
  "enter phone": "ورود شماره تلفن",
  "enter phone number": "شماره تلفن را وارد کنید",
  monthly: "ماهانه",
  "Select Date": "انتخاب تاریخ",
  "sms count": "تعداد پیامک",
  "character count": "تعداد حرف",
  "contacts count": "تعداد مخاطب",
  "contacts number": "شماره مخاطب",
  "cancel send": "لغو ارسال",
  "selected contact count": "تعداد مخاطب انتخاب شده",
  contact: "مخاطب",
  enterContactNumber: "ورود شماره تماس مخاطب",
  "contacts group": "گروه مخاطبین",
  "edit group": "ویرایش گروه",
  "contacts list": "دفترچه تلفن",
  "select from contact list": "انتخاب از دفترچه تلفن",
  "add to contacts list": "افزودن به دفترچه تلفن",
  "enter name": "نام خود را وارد کنید",
  "enter lastname": "نام خانوادگی خود را وارد کنید",
  "search name or phone": "شماره با نام را جستجو کنید",
  "edit single SMS": "ویرایش پیامک تکی",
  "edit send timing": "ویرایش زمان‌بندی ارسال",
  "Edit Confirmation": "تایید ویرایش",
  "Edit Confrimation text": "آیا از ویرایش پیام خود مطمئن هستید؟",
  "Edit Set Send Time": "ویرایش زمان دهی ارسال",
  "edit group SMS": "ویرایش پیامک گروهی",
  "retry send": "تلاش مجدد",
  "report status send": "گزارش وضعیت ارسال",
  "origin number": "شماره مبدا",
  id: "شناسه",
  "send groups sms": "ارسال پیامک گروهی",
  "First create contact group": "ابتدا گروه مخاطبین را ایجاد کنید",
  "groups contacts": "گروه‌های مخاطبین",
  "remove group contacts": "حذف گروه مخاطبین",
  "remove group text": "آیا از حذف گروه مطمئن هستید؟",
  "edit group contacts": "ویرایش گروه مخاطبین",
  "send time": "زمان ارسال",
  now: "اکنون",
  "select send time 1": "زمان را انتخاب کنید",
  "communication port": "درگاه ارتباطی",
  "Evaluator expert": "کارشناس ارزیابی کننده",
  "group evaluation": "گروه سنجش",
  "Score coefficient": "ضریب امتیاز",
  "total score": "مجموع امتیاز",
  "total scores": "مجموع امتیازات",
  minute: "دقیقه",
  second: "ثانیه",
  "submit eva": "ثبت ارزیابی",
  "edit evaluation": "ویرایش ارزیابی عملکرد",
  "Edit Evaluation": "ویرایش ارزیابی",
  "view evaluation": "مشاهده ارزیابی",
  "contact name": "نام مخاطب",
  "operator name": "نام اپراتور",
  noSearch:
    "برای نمایش گزارش، تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!",
  "User Qa QC": "کاربر",
  "sms type": "نوع پیامک",
  "sms type receive": "نوع پیامک دریافتی",
  "sms details received": "جزئیات پیامک دریافتی",
  productsList: "لیست محصولات",
  noReport: "گزارش مورد نظر پیدا نشد!",
  noReportProductsList1:
    "هنوز محصولی افزوده نشده است، برای افزودن دستی روی دکمه زیر کلیک کنید.",
  addProduct: "افزودن محصول",
  noReportProductsList2: " یا برای بارگذاری فایل روی دکمه زیر کلیک کنید.",
  noReportProductsList3: "محصول مورد جستجو یافت نشد!",
  downloadSampleFile: "دانلود نمونه فایل",
  addNewProduct: "افزودن محصول جدید",
  porductName: "عنوان محصول",
  porductCode: "کد محصول",
  deleteProduct: "حذف محصول",
  deleteProductText: "آیا از حذف محصول {item} مطمئن هستید؟",
  addNewCategory: "افزودن دسته‌بندی جدید",
  categoryList: "دسته‌بندی محصولات",
  productsNumber: "تعداد محصولات",
  viewProducts: "مشاهده محصولات",
  mainSpec: "مشخصات اصلی",
  ProductSpec: "مشخصات محصول",
  currency: "ارز",
  porductCurrency: "ارز واحد",
  porductUnitPrice: "قیمت واحد",
  porductUnit: "واحد اندازه‌گیری",
  porductCategory: "دسته‌بندی",
  porductCount: "موجودی",
  productOptions: "نسخه‌های محصول",
  addVersionValue: "افزودن مقدار ویژگی",
  versionAmount: "نام نسخه",
  versionCost: "قیمت نسخه",
  versionCount: "موجودی نسخه",
  versionFile: "بارگذاری تصویر نسخه",
  "Search Key": "کلمه کلیدی",
  register: "ثبت",
  DeleteCategoryText: "آیا از حذف دسته‌بندی  {item} مطمئن هستید؟",
  deleteCategory: "حذف دسته‌بندی",
  categoryEdit: "ویرایش دسته‌بندی",
  categoryName: "عنوان دسته‌بندی",
  deleteCategoryProducts: "محصولات این دسته‌بندی حذف شوند.",
  categoryProductsChange: "محصولات این دسته‌بندی به دسته دیگر اضافه شود.",
  categoryTitle: "عنوان دسته‌بندی",
  "enter phone number send single":
    "ورود شماره تلفن (شما میتوانید حداکثر 5 دریافت کننده انتخاب کنید)",
  "call count": "تعداد تماس",
  "call time": "مدت مکالمه",
  "waiting time": "زمان انتظار",
  "Product with storage": "محصول (با انبارداری)",
  "Product without storage": "محصول (بدون انبارداری)",
  "Enter description": "توضیحات را وارد کنید",
  retry: "تلاش مجدد",
  manager: "مدیریت",
  "evaluation with admin": "بررسی ارزیابی توسط مدیر",
  "evaluation with expret": "بررسی ارزیابی توسط کارشناس",
  "manager score submited": "امتیاز ثبت شده توسط مدیر",
  "Report Evaluation User": "گزارش عملکرد کاربران",

  "download sounds": "دانلود صوت ها",
  "download selected sounds": "دانلود صوت‌های انتخاب‌شده",
  "delete sounds": "حذف صوت ها",
  "delete selected sounds": "حذف صوت‌های انتخاب‌شده",

  selectCallDate: "انتخاب تاریخ تماس",
  user: "کاربر",
  inventory: "انبار",
  "create inventory": "ایجاد انبار",
  "inter product to inventory": "ورود محصول به انبار",
  "inventory manager": "مدیر انبار",
  province: "استان",
  city: "شهر",
  "search input inventory placeholder":
    "جستجوی نام انبار، آدرس، تلفن یا توضیحات انبار",
  "inventory empty title":
    "هنوز انبار ایجاد نشده است، برای ایجاد انبار روی دکمه زیر کلیک کنید.",
  "inventory name": "نام انبار",
  "create inventory guide text": "ثبت اطلاعات زیر اختیاری است.",
  location: "آدرس",
  "update inventory": "ویرایش انبار",
  "download sample file": "دانلود نمونه فایل",
  "inter product": "ورود محصول",
  "inventory name": "نام انبار",
  "inter date": "تاریخ ورود",
  "product version": "نسخه محصول",
  product: "محصول",
  Quantity: "موجودی",
  "add product": "افزودن محصول",
  "enter quantity": "تعداد محصول را وارد کنید",
  "inventory info": "اطلاعات انبار",
  "date call": "تاریخ تماس",
  "qaqc empty guide text":
    "برای نمایش گزارش، تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!",
  "qaqc empty list guide text":
    "برای نمایش فهرست تماس ها , تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!",
  selected: "انتخاب کنید",
  "enter phone number": "ورود شماره تماس",
  filters: "فیلترها",
  addFilter: "افزودن فیلتر",
  "qaqc no result guide text": "سابقه تماس یافت نشد!",
  "qaqc report user no result guide text": "گزارش یافت نشد!",
  "search product name  and product code": "جستجو نام , کد محصول",
  "inventory history": "تاریخچه انبار",
  "inv user": "کاربر",
  inv: "انبار را به",
  "create inv": "را ایجاد کرد",
  description: "توضیحات",
  "inv changed": "تغییر داد",
  phone: "تلفن",
  name: "نام",
  "remove inventory": "حذف انبار",
  "Products from this warehouse should be removed":
    "محصولات این انبار حذف شوند.",
  "The products from this warehouse will be transferred to another warehouse":
    "محصولات این انبار به انبار دیگر منتقل شود.",
  "select warehouse": "انتخاب انبار",
  "deleted inv": "انبار را حذف کرد",
  "View result evaluation": "مشاهده نتیجه ارزیابی",
  "Reviewing the evaluation results": "بررسی نتیجه ارزیابی"
};
